export default __webpack_public_path__ + "static/media/icon-doctor_mark.dcd197a5.svg";